module.exports = __webpack_public_path__ + "static/img/sedan-indigo.abeda1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-indigo.svg
// module id = pryf
// module chunks = 74